import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useLoader } from "../../../context/LoaderProvider.jsx";
import Employee from "../Settingsandcontrolmanagment/Food/Employee.js";
import Foodandbeveragesadvertise from "../FoodandBeverages/Foodandbeveragesadvertise.js";

const TeamManagment =() => {
 const plan = localStorage.getItem("planType") || "standard";
    const [activeTab, setActiveTab] = useState('Employee');
    const [isHovered, setIsHovered] = useState(false);
    const scrollContainerRef = useRef(null);
    const isMobile = window.innerWidth <= 768;
    const { showLoader, hideLoader } = useLoader();



    return(
        <>

        <div className="row" style={{width:"100vw"}}>
                <div className="col-lg-2"></div>
                <div className="col-lg-7 col-sm-12">
                    <p
                        className="breadcrumb maamaas-home-bredcum"
                        style={{
                            position: "fixed",
                                top: window.innerWidth <= 425 ? " 50px" : window.innerWidth > 425 && window.innerWidth <= 768 ? "60px" : "64px" ,                            
                            left: "2vw",
                            width: "100%",
                            backgroundColor: "#fff",
                            zIndex: 1000,
                            padding: "10px 0",
                            fontSize: isMobile ? "16px" : "18px",
                            fontWeight: isMobile ? "normal" : "bold",
                            textAlign: "center",
                            margin: 0,
                        }}
                    >
                        {/* <Link
                            to="/Newmainlandingpage"
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Home
                        </Link> */}
                        {/* <span className="separator"> &gt; </span> */}

                        <Link
                            to="/fooddashboard"
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Food & Beverages
                        </Link>

                        <span className="separator"> &gt; </span>

                        <Link
                            // to="/company"
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Team Managment
                        </Link>

                    </p>
                    <div style={{marginTop:window.innerWidth<769 ? "35px" :"130px"}}>
                        <Employee/>
                    </div>





        

                </div>


                <div className="col-lg-3" style={{display:window.innerWidth<=768 ? "none": "block"}}>
                    <Foodandbeveragesadvertise />
                </div>

            </div>
        </>

    );
};

export default TeamManagment;